export default "__VITE_ASSET__B9gOa_UU__"